module.exports = __webpack_public_path__ + "static/media/inventory.fa981ff8.svg";